import { useTranslation } from '../../../../hooks';
import useValidation from '../../../../hooks/useValidation';
import { ValidationConfigProps } from '../../../../hooks/useValidation/types';
import { requiredValidator } from '../../../../utils/validators/requiredValidator';
import { LoginFields, LoginFieldsKeys } from '../types';

interface IProps {
  fields: LoginFields;
}

const useEnterPasswordWithVerifyValidation = (props: IProps) => {
  const { fields } = props;

  const { translate, t } = useTranslation('login');

  const validationConfig: ValidationConfigProps = [
    {
      key: LoginFieldsKeys.Password,
      value: fields[LoginFieldsKeys.Password],
      validators: [
        requiredValidator(
          translate('validation.inputRequired', {
            fieldName: t('enterPassword.password'),
          })
        ),
      ],
    },
  ];

  return useValidation(validationConfig);
};

export default useEnterPasswordWithVerifyValidation;
